import startCase from 'lodash.startcase'

export default (node) => {
  $('#hover-node-card .card-header').text(node.name)
  
  const otnTitleValue = node.data.otnTitleValue || ''
  const otnPostbackIdValue = node.data.otnPostbackIdValue || ''
  const otnPostbackIdText = node.data.otnPostbackIdText || ''
  
  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  if (! otnTitleValue && ! otnPostbackIdValue) {
    $('#hover-node-card .card-body').html('')
  } else {
    const studlyCasedOtnPostbackIdText = startCase(otnPostbackIdText)

    let html = `<p><strong>Title:</strong> ${otnTitleValue}</p>`
    html += `<p><strong>OTN Postback:</strong> ${studlyCasedOtnPostbackIdText}</p>`
    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }

    $('#hover-node-card .card-body').html(html)
  }
}